import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { formatDateRangeCopy } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/getDateRange'
import MinutesToText from 'modules/attendance/components/MinutesToText'

import Bar from './Bar'

interface Props {
  minutes: number
  startsOn: string
  endsOn: string
  estimatedMinutes: number
}

const Header = ({ minutes, estimatedMinutes, startsOn, endsOn }: Props) => (
  <Box>
    <Box paddingTop="s12" paddingBottom="s4" gap="s4">
      <Box>
        <Text size="300" weight="semibold" color="grey1000">
          {i18n.t('clock_in.sidepanel.worked_hours.title')}
        </Text>
        <Box flexDirection="row" gap="s2">
          <Text size="200" weight="medium">
            {`${i18n.t('clock_in.sidepanel.worked_hours.period')}:`}
          </Text>
          <Text size="200" weight="normal">
            {formatDateRangeCopy(startsOn, endsOn)}
          </Text>
        </Box>
      </Box>
      <MinutesToText color="grey1000" value={minutes} size="500" weight="medium" />
    </Box>
    <Box>
      <Bar estimatedMinutes={estimatedMinutes} minutes={minutes} />
    </Box>
  </Box>
)

export default Header
